import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cigna-layout-checkout-unsecure',
  templateUrl: './layout-checkout-unsecure.component.html',
  styleUrls: ['./layout-checkout-unsecure.component.scss'],
})
export class LayoutCheckoutUnSecureComponent implements OnInit {
  isSiteDown: boolean;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    const siteDownTranslate = this.translate.instant(`global.isSiteDown`);
    this.isSiteDown = siteDownTranslate === 'true';
  }
}
